import Box from '@material-ui/core/Box'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { DocumentsLegalFormLists } from '../../../../hooks/useDocumentsLegalForm'
import { RootState } from '../../../../redux/store'
import { getInternationalizedValue } from '../../../../utils/common'
import { getDocumentDownloadUrl } from '../../../../utils/documentsLegalForm'
import DownloadButton from '../../../customButtons/downloadButton'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  buttonContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      justifyContent: 'center',
    },
  },
  nameContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
}))

interface DownloadCaseProps {
  data: DocumentsLegalFormLists
}

const DownloadCase: FC<DownloadCaseProps> = props => {
  const { data } = props

  const { language } = useSelector((state: RootState) => state.app)

  const documentName = getInternationalizedValue(
    data,
    'document_name',
    language,
  )

  const documentUrl = getInternationalizedValue(
    data,
    'model_link_txt',
    language,
  )

  const { container, nameContainer, buttonContainer } = useStyles()

  const handleDownload = () => {
    if (documentUrl.trim()) {
      if (typeof window !== 'undefined') {
        window.open(getDocumentDownloadUrl(documentUrl.trim()))
      }
    }
  }

  return (
    <Box className={container} paddingY={1}>
      <Box className={nameContainer}>
        <Typography variant="body1"> {documentName} </Typography>
      </Box>
      <Box className={buttonContainer}>
        <DownloadButton onClick={handleDownload}>
          Modèle à Télécharger
        </DownloadButton>
      </Box>
    </Box>
  )
}

export default DownloadCase
